import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import * as Styled from './LoadingView.styled';

/**
 * A loading animation that expands to the width and height of its container
 */
const Loading = ({ className, showOverlay }) => (
  <Styled.Loader className={className} showOverlay={showOverlay}>
    <Styled.Glyph>
      <img
        src="https://assets.bombas.com/image/upload/v1642172311/frontend/loading-icon-1.svg"
        alt=""
      />
    </Styled.Glyph>
    <Styled.Glyph delay={700}>
      <img
        src="https://assets.bombas.com/image/upload/v1642172311/frontend/loading-icon-2.svg"
        alt=""
      />
    </Styled.Glyph>
    <Styled.Glyph delay={1400}>
      <img
        src="https://assets.bombas.com/image/upload/v1642172311/frontend/loading-icon-3.svg"
        alt=""
      />
    </Styled.Glyph>
  </Styled.Loader>
);

const LoadingView = ({ showOverlay }) => (
  <Styled.LoadingView>
    <Loading showOverlay={showOverlay} />
  </Styled.LoadingView>
);

/**
 * Appends a full page loader to the DOM
 */
const LoadingViewContainer = ({ showOverlay }) => {
  const containerRef = useRef(document.createElement('div'));

  useEffect(() => {
    const element = containerRef.current;

    document.body.appendChild(element);
    return () => {
      document.body.removeChild(element);
    };
  }, []);

  return createPortal(<LoadingView showOverlay={showOverlay} />, containerRef.current);
};

Loading.propTypes = {
  className: PropTypes.string,
  showOverlay: PropTypes.bool
};

Loading.defaultProps = {
  className: '',
  showOverlay: true
};

LoadingView.propTypes = {
  showOverlay: PropTypes.bool
};

LoadingView.defaultProps = {
  showOverlay: true
};

export { Loading, LoadingView };
export default LoadingViewContainer;
